import { MenuFoldOutlined, UnorderedListOutlined } from '@ant-design/icons'
import { Radio } from 'antd'
import React from 'react'

export function ViewModeRadio({
  selectedViewStyle,
  setSelectedViewStyle,
}: {
  selectedViewStyle: 'flat' | 'grouped'
  setSelectedViewStyle: (viewStyle: 'flat' | 'grouped') => void
}) {
  return (
    <Radio.Group
      style={{ minWidth: 'max-content' }}
      value={selectedViewStyle}
      onChange={(e) => setSelectedViewStyle(e.target.value)}
      optionType='button'
      buttonStyle='solid'
      options={[
        {
          label: 'By Invoice Group',
          value: 'grouped',
          icon: <MenuFoldOutlined />,
        },
        {
          label: 'Flat',
          value: 'flat',
          icon: <UnorderedListOutlined />,
        },
      ].map((option) => ({
        label: (
          <>
            {option.icon}
            <span style={{ marginLeft: 8 }}>{option.label}</span>
          </>
        ),
        value: option.value,
      }))}
    />
  )
}
